// import lang from 'element-ui/lib/locale/lang/kh' // 引入element语言包-马来语(暂无)
const lang = {
  el: {
    colorpicker: {
      confirm: 'Tentukan',
      clear: 'Kosong',
    },
    datepicker: {
      now: 'Pada masa ini',
      today: 'Hari ini',
      cancel: 'Batalkan',
      clear: 'Kosong',
      confirm: 'Tentukan',
      selectDate: 'Tarikh pilih',
      selectTime: 'Pilih masa',
      startDate: 'Tarikh mula',
      startTime: 'Masa mula',
      endDate: 'Tarikh akhir',
      endTime: 'Masa tamat',
      prevYear: 'Tahun lepas',
      nextYear: 'Tahun berikutnya',
      prevMonth: 'Bulan lepas',
      nextMonth: 'Bulan depan',
      year: 'Tahun',
      month1: 'Januari',
      month2: 'Februari',
      month3: 'Mac',
      month4: 'April',
      month5: 'Mei',
      month6: 'Jun',
      month7: 'Julai',
      month8: 'Ogos',
      month9: 'September',
      month10: 'Oktober',
      month11: 'November',
      month12: 'Disember',
      // week: '周次',
      weeks: {
        sun: 'Hari',
        mon: 'Satu',
        tue: 'Dua',
        wed: 'Tiga',
        thu: 'Empat',
        fri: 'Lima',
        sat: 'Enam',
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',
      },
    },
    select: {
      loading: 'Memuatkan',
      noMatch: 'Tiada data yang sepadan',
      noData: 'Tiada data',
      placeholder: 'Sila pilih',
    },
    cascader: {
      noMatch: 'Tiada data yang sepadan',
      loading: 'Memuatkan',
      placeholder: 'Sila pilih',
      noData: 'Belum ada data',
    },
    pagination: {
      goto: 'Pergi ke',
      pagesize: 'Perkara/Halaman',
      total: 'Jumlah {total}',
      pageClassifier: 'Halaman',
    },
    messagebox: {
      title: 'Prompt',
      confirm: 'Tentukan',
      cancel: 'Batalkan',
      error: 'Data yang dimasukkan tidak sah!',
    },
    upload: {
      deleteTip: 'Tekan padam untuk memadam',
      delete: 'Padam',
      preview: 'Lihat gambar',
      continue: 'Teruskan muat naik',
    },
    table: {
      emptyText: 'Belum ada data',
      confirmFilter: 'Pemeriksaan',
      resetFilter: 'Tetapkan semula',
      clearFilter: 'Semua',
      sumText: 'Jumlah',
    },
    tree: {
      emptyText: 'Belum ada data',
    },
    transfer: {
      noMatch: 'Tiada data yang sepadan',
      noData: 'Tiada data',
      titles: ['Senarai 1', 'Senarai 2'],
      filterPlaceholder: 'Sila masukkan carian anda',
      noCheckedFormat: 'Jumlah {total} Perkara',
      hasCheckedFormat: 'Dipilih {checked}/{total} Perkara',
    },
    image: {
      error: 'Beban gagal',
    },
    pageHeader: {
      title: 'Kembali',
    },
  },
}

const messages = {
  message: {
    'text': 'Good good study, Day day up',
  },
  ...lang,
}

export default messages
